/**
 * This is the entry component for the auth module.
 */

import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-master',
  templateUrl: './master.component.html',
  styleUrls: ['./master.component.scss']
})
export class MasterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
